import React from 'react';
import { apiGet, getHostApi } from '../../store/apiWrapper';
import { Circles } from '../common/loadingComponent';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { RatioBookRender, RatioBookBodyItem } from './ratioBookClass';
import { Translate } from 'react-localize-redux';
import ExcelExportButton from '../common/excelExportButton';
import HorizontalScrollControl from '../layoutItems/horizontalScrollControl';
import NoDataComponent from '../common/noDataComponent';

import "../../css/search/search.scss";

class RatioBookBranchesResult extends React.Component {
    state = {
        data: [],
        isLoading: false,
    };

    render() {
        const { year, nace } = this.props.computedMatch.params;
        if (isNullOrUndefined(year) || isNullOrUndefined(nace))
            return (<NoDataComponent />);

        if (this.state.isLoading)
            return <Circles />

        return (
            <>
                <div className='card card-special' >
                    <div className='card-body'>
                        {this.renderTitle()}
                        <HorizontalScrollControl withMarginBottom>
                            <table className="table table-report-section-2-general-asm without-hover w-100">
                                <tbody>{this.renderHeader()}</tbody>
                                <tbody>{this.renderLabels()}</tbody>
                                <tbody>{this.renderBody()}</tbody>
                            </table>
                        </HorizontalScrollControl>
                        <ExcelExportButton report="overview-by-okec" ratiobook={{ year: year, okec: nace }} />
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        const { year, nace } = this.props.computedMatch.params;

        apiGet(`${getHostApi()}/api/ratiobook/overview-by-okec?year=${year}&okec=${nace}`,
            null,
            (data) => this.success(data.data),
            () => this.onError()
        );
    }

    renderTitle() {
        if (this.state.data.length == 0)
            return;

        const { year } = this.props.computedMatch.params;

        return (
            <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom">
                <h5 className="underlined-title rb-header">
                    <Translate id="RatioBook.Common.ReportType" options={{ renderInnerHtml: true }} />
                    {`: ${this.state.data.okec} - ${this.state.data.title} (${year})`}
                </h5>
            </span>
        );
    }

    renderHeader() {
        if (this.state.data.length == 0)
            return;

        const { year, header, labels, body } = this.state.data;
        const headerData = new RatioBookRender(year, header, labels, body);
        return headerData.renderHeader();
    }

    renderLabels() {
        if (this.state.data.length == 0)
            return;

        const { year, header, labels, body } = this.state.data;
        const headerData = new RatioBookRender(year, header, labels, body);
        return headerData.renderLabels();
    }

    renderBody() {
        if (this.state.data.length == 0)
            return;

        const { year, body } = this.state.data;
        return body.map(item => {
            const record = new RatioBookBodyItem(year, item);
            return record.renderBodyItem();
        });
    }

    success(data) {
        this.setState({ data: data, isLoading: false });
    }

    onError() {
        this.setState({ isLoading: false });
    }
}

export default RatioBookBranchesResult;